import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const ExtendSessionMutation = graphql(`
    mutation ExtendSession {
        token: extendSession
    }
`);

export type ExtendSessionMutationVariables = VariablesOf<typeof ExtendSessionMutation>;
